export enum CorrespondenceGroup {
  Policy = 1,
  GeneralDocuments = 2
}
